import React, { memo, useCallback } from "react";
import cx from "classnames";

import Screen from "./ConnectedScreen";
import CityButton from "../components/CityButton";
import Alert from "../components/Alert";

function OutcallScreen({
  value,
  city,
  model,
  outcalls,
  incalls,
  goToScreen,
  setOutcall,
}) {
  const handleOutcall = useCallback(() => setOutcall(true));
  const handleIncall = useCallback(() => setOutcall(false));
  const goToTime = useCallback(() => goToScreen("time"));

  const noOutcall = model && model.online && !outcalls.length;
  const noIncall = model && model.online && !incalls.length;

  let modelInfo = null;

  if (noOutcall) {
    modelInfo = `**${model.name}** does not provide outcall`;
  } else if (noIncall && city.incall) {
    modelInfo = `**${model.name}** does not provide incall`;
  }

  return (
    <Screen title="In or outcall?" isActive onNext={goToTime}>
      <CityButton
        name="outcall"
        full
        className={cx({ active: value })}
        onClick={handleOutcall}
        help="She comes to you"
        disabled={noOutcall}
      />
      <CityButton
        name="incall"
        full
        className={cx({ active: !value })}
        onClick={handleIncall}
        help="You go to her"
        disabled={!city.incall || noIncall}
      />
      {!city.incall && (
        <Alert
          info
          className="u-mt"
          text={`Sorry incall is not available in ${city.name}`}
        />
      )}
      {modelInfo !== null && <Alert info className="u-mt" text={modelInfo} />}
    </Screen>
  );
}

// @connect
import { bindActionCreators as bindActions } from "redux";
import { connect } from "react-redux";
//
import { goToScreen } from "../modules/modal";
import { setOutcallAction } from "../modules/booking/actions";
import {
  getCity,
  getModel,
  getModelOutcalls,
  getModelIncalls,
} from "../selectors";

const state = (state) => {
  const model = getModel(state);

  const outcalls = model ? getModelOutcalls(state) : [];
  const incalls = model ? getModelIncalls(state) : [];

  return {
    value: state.booking.outcall,
    city: getCity(state),
    model,
    outcalls,
    incalls,
  };
};

const actions = (dispatch) =>
  bindActions({ setOutcall: setOutcallAction, goToScreen }, dispatch);

export default connect(state, actions)(OutcallScreen);
